module.exports = __webpack_public_path__ + "img/天津大学.bf3dd787.png";